<template>
  <div>
    <el-card class="mb-2" shadow="never">
      <div class="d-flex justify-content-between" style="align-items: stretch;">
        <div class="d-flex mr-2">
          <div>
            <el-image
              :src="baseInfo.defaultImageUrl || '/image/static/img/nopic.jpg'"
              :preview-src-list="[
                baseInfo.defaultImageUrl || '/image/static/img/nopic.jpg',
              ]"
              style="width: 134px; height: 88px"
              fit="cover"
            >
              <div slot="error">
                <img
                  src="/image/static/img/nopic.jpg"
                  style="width: 120px; height: 80px"
                />
              </div>
            </el-image>
          </div>
          <div class="ml-3 d-flex align-items-center">
            <div>
              <h5 style="color: #101010;">
                {{ baseInfo.fabricSeriesName || '' }}
              </h5>
              <h6 style="color: #303133;font-size: 14px;">
                {{ baseInfo.fabricSeriesNameEn || '' }}
              </h6>
              <div class="d-flex align-items-center">
                <div style="height: 29px;line-height: 29px;overflow: hidden;">
                  <span style="font-size: 14px; color: #606266">
                    No：{{ baseInfo.fabricSeriesNo || '面料系列编号自动生成' }}
                  </span>
                  <el-divider
                    direction="vertical"
                    v-if="baseInfo.fabricSeriesCode"
                  />
                  <el-tag
                    v-if="baseInfo.fabricSeriesCode"
                    class="mx-1"
                    size="mini"
                    :type="
                      baseInfo.fabricSeriesStatus === 'Y'
                        ? 'success'
                        : baseInfo.fabricSeriesStatus === 'N'
                        ? 'info'
                        : baseInfo.fabricSeriesStatus === 'P'
                        ? 'primary'
                        : baseInfo.fabricSeriesStatus === 'R'
                        ? 'warning'
                        : 'danger'
                    "
                  >
                    {{ baseInfo.v_fabricSeriesStatus }}
                  </el-tag>
                  <el-divider
                    direction="vertical"
                    v-if="baseInfo.fabricSeriesCode"
                  />
                  <span
                    style="font-size: 14px; color: #606266"
                    v-if="baseInfo.fabricSeriesCode"
                  >
                    Modify：{{ baseInfo.modifyByName || '--' }} at
                    {{ baseInfo.modifyDate || '--' }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex align-items-end">
          <div class="switch-tabs_wrappers">
            <div class="switch-tabs">
              <div
                v-for="item in switchTabs"
                :key="item.value"
                class="switch-tabs_items"
                :class="{
                  active: item.value === activeName,
                  disabled: item.disabled,
                }"
                @click="!item.disabled ? (activeName = item.value) : () => {}"
              >
                <span>{{ item.label }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-card>
    <div v-show="activeName == 'base'">
      <el-card shadow="always" style="box-shadow:none;">
        <EditForm
          ref="editForm"
          :formDisabled="formDisabled"
          :fabricSeriesCode="fabricSeriesCode"
          :imageDisabled="imageDisabled"
          :form="formData"
          @loaded="loaded"
        />
      </el-card>
      <el-card
        shadow="always"
        style="box-shadow:none"
        v-if="fabricDisabled"
        class="mt-2"
      >
        <FabricTable
          class="mt-1"
          v-if="fabricDisabled"
          ref="fabricTable"
          :fabricSeriesCode="fabricSeriesCode"
          :addFabric="addFabric"
          :form="formData"
        />
      </el-card>
    </div>
    <el-card v-if="activeName == 'image'" shadow="never">
      <SeriesImage
        :disabled="baseInfo.fabricSeriesStatus === 'D'"
        :fabricSeriesCode="fabricSeriesCode"
        @reload="getBaseInfoData"
      />
    </el-card>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
import FabricTable from '../components/fabric-table'
import SeriesImage from '../components/series-image'
export default {
  name: 'ecom-awsSample-fabricSeries-detail',
  components: {
    EditForm,
    FabricTable,
    SeriesImage,
  },
  data() {
    return {
      fabricDisabled: false,
      formData: {},
      baseInfo: {},
      activeName: 'base',
    }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    fabricSeriesCode() {
      return this.params.fabricSeriesCode
    },
    //禁用表单 + 保存按钮 控制 禁用表单时保存按钮不显示
    formDisabled() {
      return this.pageType === 'detail' || this.pageType === 'addFabric'
    },
    //图片维护按钮控制
    imageDisabled() {
      return this.pageType === 'detail' || this.pageType === 'add'
    },
    addFabric() {
      return this.pageType === 'addFabric'
    },
    switchTabs() {
      return [
        {
          label: this.$l('switchTabs_label_base') || '基本信息',
          value: 'base',
        },
        {
          label: this.$l('switchTabs_label_image') || '系列图片',
          value: 'image',
          disabled: !this.fabricSeriesCode,
        },
      ]
    },
  },
  mounted() {},
  methods: {
    loaded(data) {
      this.formData = data || {}
      this.baseInfo = { ...this.formData }
      this.fabricDisabled = this.formData.fabricSeriesStatus === 'Y'
    },

    getBaseInfoData() {
      if (!this.fabricSeriesCode) return
      this.$api
        .masterFabricSeriesDetail({
          fabricSeriesCode: this.fabricSeriesCode,
        })
        .then((res) => {
          this.baseInfo = res.body || {}
          this.fabricDisabled = this.baseInfo.fabricSeriesStatus === 'Y'
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 15px 0;
}
.edit_form {
  padding: 15px 15px 5px 15px;
  border-radius: 5px;
  background-color: #fff;
}
.mt_10 {
  margin-top: 10px;
}
.switch-tabs {
  display: flex;
  .switch-tabs_items {
    padding: 4px 8px;
    color: #6c757d;
    font-size: 14px;
    margin-right: 20px;
    border-radius: 4px;
    cursor: pointer;
    min-width: max-content;
  }
  .switch-tabs_items:hover,
  .switch-tabs_items.active {
    color: #007bff;
    background-color: #f8f8f9;
  }
  .switch-tabs_items.disabled {
    cursor: no-drop;
  }
  .switch-tabs_items.disabled:hover {
    color: #8cc5ff;
  }
  .switch-tabs_items:last-child {
    margin-right: 0;
  }
}
</style>
